import { render, staticRenderFns } from "./NotFoundErrorPage.vue?vue&type=template&id=6cef0ff5&scoped=true&"
import script from "./NotFoundErrorPage.vue?vue&type=script&lang=ts&"
export * from "./NotFoundErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotFoundErrorPage.vue?vue&type=style&index=0&id=6cef0ff5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef0ff5",
  null
  
)

export default component.exports